export default "__VITE_ASSET__142f1966__"